/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:18:19
 */
export default {
  lang: "英语",
  landing: {
    name1: "باز کردن Carlcare",
    name2: "رزرو کنید",
    name3: "با Carlcare، هر وقت خواستید می‌توانید سفارش خود را بررسی کنید.",
    name4: "",
    name5: "به سمت راست بکشید",
    name6: "تأیید کامل شد",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "انتخاب مدل دستگاه",
    name2: "توضیح خرابی:",
    name3: "برای انتخاب فروشگاه خدمات رسانی لمس کنید",
    name4: "فروشگاه خدمات رسانی:",
    name5: "زمان رزرو:",
    name6: "لطفاً مشکل دستگاه خود را با جزئیات شرح دهید!",
    name7: "برای انتخاب زمان رسیدن لمس کنید",
    name8: "لطفاً جزئیات تماس با خود را به درستی وارد کنید تا بتوانیم با شما تماس بگیریم",
    name9: "زمان رزرواسیون موجود به شرح زیر است",
    name10: "لطفا شماره موبایل خود را وارد کنید",
    name11: "قیمت",
    name12: "اطلاعات شخصی:",
    name13: "لطفاً نام خود را وارد کنید",
    name14: "ارسال",
    name15: "لغو",
    name16: "تایید",
  },
  shops: {
    name1: "بر اساس برندی که انتخاب می‌کنید، فروشگاه‌های زیر می‌توانند به شما خدمات ارائه دهند!",
    name2: "به زودی به فروشگاه های خرده فروشی بیشتری می آید! با ما همراه باشید!",
  },
  price: {
    name1: "برند",
    name2: "مدل",
    name3: "مورد",
    name4: "قیمت",
    name5: "یک یادآوری دوستانه:",
    name6: "این قیمت‌ها فقط برای اطلاع شما هستند و قیمت واقعی به شرایط دستگاه شما بستگی دارد.",
    name7: "اگر هیچ نماد خاصی وجود نداشته باشد، واحد قیمت همان واحد پولی محلی خواهد بود.",
    name8: "متأسفیم! هیچ اطلاعات قیمتی در منطقه فعلی وجود ندارد.",
    name11:"هزینه کار",
    name12:"قیمت کل",
    name13: "5. اگر هزینه کار \"/\" است، به معنای این است که باید در مورد هزینه کار با فروشگاه مشورت شود.",
    item_main_board: "برد اصلی",
    item_screen_frame: "صفحه نمایش (قاب)",
    item_screen_screen_frame: "صفحه‌نمایش دوم (قاب)",
    item_touch_screen: "صفحه لمسی",
    item_camera: "دوربین",
    item_fixed_focus_camera: "دوربین فوکوس ثابت",
    item_auto_focus_camera: "دوربین فوکوس خودکار",
    item_screen: "صفحه‌نمایش",
    item_secondary_screen: "صفحه‌نمایش دوم",
    item_fingerprint_module: "ماژول اثر انگشت",
    item_speaker: "بلندگو",
    item_receiver: "گیرنده",
    item_small_board: "برد کوچک",
    item_battery_cover: "کاور باتری",
    item_battery: "باتری",
    item_charger: "شارژر",
    item_usb_cable: "کابل USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "داده ای وجود ندارد",
    name2: "ارائه دهنده خدمات:",
    name3: "برند خدمات:",
    name4: "تلفن:",
    name5: "کمیت سفارش:",
    name6: "امتیاز خدمات رسانی",
    name7: "محیط خدمات رسانی:",
    name8: "برخورد خدمات رسانی:",
    name9: "بهره وری خدمات رسانی:",
    name10: "کیفیت خدمات رسانی:",
    name11: "ارزیابی مشتری",
    name12:"تا",
    name13:"بسته شده",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "باز کردن Carlcare",
    name1: "لطفاً از اطلاعات رزرواسیون عکس صفحه بگیرید و از آن به عنوان رسیدی برای دسترسی به اطلاعات سرویس اولویت‌دار استفاده کنید.",
    name2: "با موفقیت ارسال شد",
    name3: "1. پاکسازی داده‌ها",
    name4: "لطفاً پیشاپیش از داده‌های خصوصی مهم در تلفن خود پشتیبان‌گیری کنید",
    name5: "2. غیرفعال کردن رمز عبور روشن کردن",
    name6: "پیش از رفتن به فروشگاه سرویس، لطفاً:",
    name7: "فروشگاه خدمات رسانی:",
    name8: "زمان رزرو:",
    name9: "توضیح خرابی:",
    name10: "مدل دستگاه:",
    name11: "شماره سفارش:",
    name12: "اطلاعات سفارش",
  },
  title: {
   
    name1: "از کشورهای زیر پشتیبانی می‌کند:",
    name2: "انتخاب مدل",
    name3: "رزرواسیون",
    name4: "جزئیات فروشگاه خدمات رسانی",
    name5: "انتخاب فروشگاه خدمات رسانی",
  },
  error: {
    
    name1: "داده‌های موجود نیست. لطفاً اطلاعات تعمیر خود را بررسی کنید",
    name2: "کمک بیشتر لازم دارید؟ لطفاً با ما تماس بگیرید.",
    name3: "متأسفیم، مرکز Carlcare در منطقه فعلی وجود ندارد.",
    name4: "لطفاً در ابتدا یک مرکز سرویس انتخاب کنید",
    name5: "انجام نشد",
    name6: "لطفاً در ابتدا مدل دستگاه را انتخاب کنید",
    name7: "جزئیات",
    name8: "لطفاً نیازهای خود را با جزئیات شرح دهید",
    name9: "",
  },
  add1:{
    "name0": "fa",
    "name1": "سفارش شما تأیید شده است. منتظر رسیدن شما هستیم.",
    "name2": "شهر را انتخاب کنید",
    "name3": "لطفاً یک شماره تلفن %1$s رقمی وارد کنید.",
    "name4": "ساعات کاری روز\u200cهای هفته",
    "name5": "دوشنبه",
    "name6": "سه شنبه",
    "name7": "چهارشنبه",
    "name8": "پنج شنبه",
    "name9": "جمعه",
    "name10": "شنبه",
    "name11": "یکشنبه",
    "name12": "کشور را وارد و جستجو کنید"   
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "دیگران",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"برای تغییر مسیر ضربه بزنید",
    name3:"برای امتیاز دادن به سفارش، برنامه Carlcare را باز کنید",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"سرویس را انتخاب کنید",
    name7:"تمیز کردن رایگان",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "اطلاعات نادرست",
    "cancelReason1": "نمی‌توان به موقع رسید",
    "cancelReason2": "سفارش تکراری/سفارش من نیست",
    "cancelReason3": "خطا تکرار نمی‌شود",
    "cancelReason4": "فقط برای تست/پرسش/رویداد/…",
    "cancelReason5": "قیمت بالا",
    "cancelReason6": "کمبود مواد",
    "cancelReason7": "بدون خدمات متمایز",
    "cancelReason8": "فروشگاه خیلی دور است",
    "cancelReason9": "فروشگاه بسته است",
    "cancelReason10": "نگرش بد مشتریان به خدمات",
    "cancelReason11": "تعویض/تعمیر سایر برندها",
    "cancelReason12": "فروشگاه را نمی‌توان یافت",
    "cancelReason13": "دیگر",
    "cancelOrder": "لغو سفارش",
    "reason_dialog_title": "لطفاً دلیل لغو را به ما بگویید",
    "Cancel": "لغو",
    "OK": "بله",
    "name1": "کد تأیید را وارد نمایید",
    "name2": "کد تأیید نامعتبر",
    "repair_reservation_detail_canceled": "این سفارش لغو شده است!",
    "purchase_cancel_dialog_content": "آیا لغو سفارش را تأیید می‌کنید؟",
    "yes": "بله",
    "no": "خیر"
}
};
